<div
    *ngIf="regData?.testSession"
    class="panel"
>
    <div
        class="panel-body"
        *ngIf="isCELPIPTestSelection"
    >
        <div class="row">
            <div class="col-md-3 col-lg-2 text-center py-2">
                <img
                    [src]="testLogo"
                    alt="test-logo"
                />
            </div>
            <div class="col-md-9 col-lg-10">
                <p [innerHTML]="testTypeDisplayName | safe:'html'"></p>
                <p *ngIf="regData.testSession?.testTypeId === TestTypeEnum.CELPIP_LS">It is accepted by Immigration, Refugees and Citizenship Canada for <strong>Canadian citizenship</strong>.</p>
            </div>
        </div>
        <p>
            <span *ngIf="regData.selectedTestPurposeOption?.parentId === 'null_2'">It is accepted by a number of organizations for employment requirements.</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CICC">It is accepted by the College of Immigration and Citizenship Consultants (CICC).</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.RealEstateCouncilofBC">It is accepted by the BC Financial Services Authority (BCFSA).</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.RECA">It is accepted by the Real Estate Council of Alberta (RECA).</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.SaskatchewanRealtors">It is accepted by the Saskatchewan Real Estate Commission (SREC).</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.AdmissionToInstitution">It is accepted for admission to select universities, colleges, and vocational programs.</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CollegeOfPhysiciansAndSurgeons">It is accepted for admission to select Colleges of Physicians and Surgeons.</span>
            <span *ngIf="regData.selectedTestPurposeOption?.testPurposeId === TestPurposeEnum.CollegeOfDenturists">It is accepted for admission to select Colleges of Denturists.</span>
            <span *ngIf="!hidePR">It is designated by Immigration, Refugees and Citizenship Canada for <strong>permanent resident</strong> status in Canada.</span>
        </p>
    </div>
    <div
        *ngIf="regData.testSession.isWebDelivery && !isCELPIPTestSelection"
        class="location-date panel-body"
    >
        <div class="row">
            <div class="col-sm-3">
                <h5>Test:</h5>
            </div>
            <div class="col-sm-3">
                <span [ngClass]="testTypeCssClass">{{regData.testSession.testTypeDisplayName}} Test</span>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <h5>Test Date & Time:</h5>
            </div>
            <div class="col-sm-9">
                {{testDate| customDate: 'selectedTestFormatDateTime'}}
                <br /> (Time Zone: {{localTimeZone}})
            </div>
        </div>
        <hr />
        <app-web-delivery-requirements></app-web-delivery-requirements>
    </div>
</div>
